

const BODY_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export function normalizeApiBase(baseUrl) {
  return typeof baseUrl === "string" ? baseUrl.replace(/\/$/, "") : "";
}

export function isApiOriginRequest(url, baseUrl) {
  if (typeof url !== "string") return false;
  return (
    url.startsWith(normalizeApiBase(baseUrl)) ||
    url.startsWith(baseUrl)
  );
}

export function isMutatingMethod(method) {
  return BODY_METHODS.has((method || "get").toUpperCase());
}

export function parseCsrfTokenFromResponse(data) {
  const t = data?.csrf_token;
  if (typeof t !== "string" || !t) {
    throw new Error("csrf_token missing in response");
  }
  return t;
}

export function getErrorResponseMessage(data) {
  if (data && typeof data === "object" && data.message != null) {
    return String(data.message);
  }
  return "";
}

export function isCsrfForbiddenError(status, message) {
  return status === 403 && typeof message === "string" && message.includes("CSRF");
}

/**
 * @param {import("axios").AxiosError} error
 */
export function isAxiosCancelError(error, axios) {
  return (
    error?.name === "CanceledError" ||
    error?.code === "ERR_CANCELED" ||
    (typeof axios.isCancel === "function" && axios.isCancel(error))
  );
}

/**
 * Builds axios config for invokeApi-style calls.
 * @param {object} opts
 * @param {string} opts.baseUrl
 * @param {string} opts.path - relative to base (e.g. `api/admin_users/session_check`)
 * @param {string} [opts.method]
 * @param {Record<string, string>} [opts.headers]
 * @param {Record<string, unknown>} [opts.queryParams]
 * @param {object|FormData} [opts.postData]
 * @param {boolean} [opts.skip401Handler]
 * @param {AbortSignal|null} [opts.signal]
 * @param {string} opts.appContext - `X-App-Context` value
 */
export function buildInvokeRequestConfig({
  baseUrl,
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
  skip401Handler = false,
  signal = null,
  appContext,
}) {
  const reqObj = {
    method,
    url: baseUrl + path,
    headers: { "X-App-Context": appContext, ...headers },
    withCredentials: true,
    skip401Refresh: skip401Handler,
  };

  if (signal) {
    reqObj.signal = signal;
  }

  reqObj.params = queryParams;

  const m = method.toUpperCase();
  if (BODY_METHODS.has(m)) {
    reqObj.data = postData;
  }

  if (postData instanceof FormData) {
    reqObj.headers["Content-Type"] = undefined;
  }

  return reqObj;
}

export function isCanceledResponse(result) {
  return result?.canceled === true;
}
